/**
 * Lo de abajo del final del repaso (la pantalla C, card #604): los días seguidos
 * —los mismos del perfil (`/progress/totals`), que ya cuentan el repaso de hoy— y
 * cuántas te tocan mañana (`/corrections/due?ahead=1`, con lo de hoy guardado).
 * Cada dato que no llega queda en `null` y no se muestra: nunca un 0 inventado.
 */
import { browserTimeZone, getProgressTotals } from '../../../lib/englishApi.js';
import { fetchDueCorrections } from '../../../lib/correctionReviewApi.js';

export interface ReviewAhead {
  streakDays: number | null;
  tomorrow: number | null;
}

export async function loadReviewAhead(): Promise<ReviewAhead> {
  // Un pedido que tira antes de devolver la promesa también queda en `rejected`.
  const [totals, due] = await Promise.allSettled([
    Promise.resolve().then(() => getProgressTotals(browserTimeZone())),
    Promise.resolve().then(() => fetchDueCorrections(undefined, { ahead: true })),
  ]);
  if (totals.status === 'rejected') console.warn('[review] streak failed', totals.reason);
  if (due.status === 'rejected') console.warn('[review] tomorrow failed', due.reason);
  return {
    streakDays: totals.status === 'fulfilled' ? totals.value.currentStreak : null,
    tomorrow: due.status === 'fulfilled' ? due.value.items.length : null,
  };
}
